import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MD - Dermatology, Fellowship in Trichology",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "PRP Hairfall Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, MD - Dermatology, Fellowship in Aesthetic Medicine",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Advanced PRP Therapy Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MD - Dermatology, Fellowship in Hair Restoration",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "PRP Hair Regrowth Expert"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MD - Dermatology, Fellowship in Trichology",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Natural Hair Restoration Specialist"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MD - Dermatology, Fellowship in PRP Therapy",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Customized PRP Treatment Expert"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, DNB - Dermatology",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Hairfall PRP Therapy Specialist"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Hairfall PRP Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert PRP therapy for natural hair regrowth with 90% success rate. Non-surgical solution for hair thinning and baldness.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const HairfallPRP = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Hairfall PRP Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Natural Hair Regrowth with 90% Success Rate. Non-Surgical PRP Therapy for Hair Thinning and Pattern Baldness.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Free Hair Analysis
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>90%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Treatment Success Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>45-60</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Minutes Procedure Time</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>3-6</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Months Visible Results</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>{`0%`}</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Downtime Required</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "benefits", label: "Benefits", icon: "🔍" },
              { id: "procedure", label: "Procedure", icon: "🎯" },
              { id: "results", label: "Results", icon: "🔬" },
              { id: "candidates", label: "Candidates", icon: "⚕️" },
              { id: "maintenance", label: "Maintenance", icon: "🔄" },
              { id: "faq", label: "FAQ", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Hairfall PRP Treatment</span>
            </h2>
          </div>

          {/* What is PRP Treatment */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding PRP (Platelet-Rich Plasma) Therapy
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                PRP (Platelet-Rich Plasma) therapy is a revolutionary non-surgical treatment that uses your own blood's 
                natural healing properties to stimulate hair growth and combat hair loss. The procedure involves extracting 
                a small amount of your blood, processing it to concentrate the platelets and growth factors, and then 
                injecting this powerful plasma back into your scalp to rejuvenate hair follicles and promote natural regrowth.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Natural Approach</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Uses your body's own healing mechanisms without chemicals or drugs. 
                      Completely natural, safe, and harnesses your blood's growth factors for hair regeneration.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Comprehensive Benefits</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Stimulates dormant hair follicles, increases hair thickness, reduces hair fall, 
                      improves hair density, and enhances overall hair quality and health.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Benefits & Advantages */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Benefits & Advantages of PRP Therapy
            </h3>

            <div className="row">
              {[
                {
                  title: "Natural Hair Regrowth", 
                  description: "Stimulates dormant hair follicles to resume natural growth cycle and produce new hair",
                  details: "Activates your body's own healing mechanisms"
                },
                {
                  title: "Non-Surgical Solution", 
                  description: "No incisions, no scarring, and no general anesthesia required for the procedure",
                  details: "Minimally invasive with zero downtime"
                },
                {
                  title: "Safe & Natural", 
                  description: "Uses your own blood components, eliminating risk of allergic reactions or rejection",
                  details: "Autologous treatment - uses your own cells"
                },
                {
                  title: "Increased Hair Thickness", 
                  description: "Strengthens existing hair strands and increases diameter for fuller appearance",
                  details: "Improves hair density and volume"
                },
                {
                  title: "Reduced Hair Fall", 
                  description: "Significantly decreases daily hair shedding and strengthens hair roots",
                  details: "Prevents further hair loss progression"
                },
                {
                  title: "Improved Hair Quality", 
                  description: "Enhances hair texture, shine, and overall health of scalp and hair",
                  details: "Comprehensive hair and scalp improvement"
                }
              ].map((benefit, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {benefit.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {benefit.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {benefit.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* PRP Techniques & Methods */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              PRP Treatment Techniques & Methods
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Standard PRP Therapy",
                    description: "Traditional PRP preparation with single spin centrifugation for platelet concentration",
                    treatment: "Ideal for mild to moderate hair loss cases"
                  },
                  {
                    type: "Advanced PRP with Growth Factors",
                    description: "Enhanced PRP with additional growth factor activation for superior results",
                    treatment: "For advanced hair thinning and pattern baldness"
                  },
                  {
                    type: "PRP with Microneedling",
                    description: "Combines PRP with microneedling to enhance absorption and stimulate collagen",
                    treatment: "Maximum growth factor penetration"
                  },
                  {
                    type: "Matrix PRP Therapy",
                    description: "Specialized PRP preparation with optimal platelet concentration and activation",
                    treatment: "Customized for individual hair loss patterns"
                  },
                  {
                    type: "PRP with Stem Cell Therapy",
                    description: "Combines PRP with adipose-derived stem cells for enhanced regeneration",
                    treatment: "Advanced hair restoration approach"
                  },
                  {
                    type: "Customized PRP Protocols",
                    description: "Tailored treatment plans based on individual hair loss causes and patterns",
                    treatment: "Personalized approach for optimal results"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Candidates & Considerations */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Ideal Candidates & Treatment Considerations
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Ideal Candidates</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Men and women with early to moderate hair thinning</li>
                      <li style={{ marginBottom: "10px" }}>Individuals with pattern baldness (androgenetic alopecia)</li>
                      <li style={{ marginBottom: "10px" }}>Those experiencing increased hair shedding</li>
                      <li style={{ marginBottom: "10px" }}>Patients wanting to avoid surgical hair restoration</li>
                      <li>People with overall good health and realistic expectations</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Important Considerations</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Stage and pattern of hair loss</li>
                      <li style={{ marginBottom: "10px" }}>Overall health and medical conditions</li>
                      <li style={{ marginBottom: "10px" }}>Realistic expectations about results timeline</li>
                      <li style={{ marginBottom: "10px" }}>Commitment to multiple treatment sessions</li>
                      <li>Willingness to follow maintenance protocol</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Procedure */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              PRP Treatment Procedure & Process
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Step-by-Step PRP Procedure
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    The PRP treatment process is straightforward, minimally invasive, and typically completed 
                    within 60-90 minutes with immediate return to normal activities.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Treatment Steps:</h6>
                    <div className="row">
                      <div className="col-12">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}><strong>Blood Draw:</strong> Small blood sample collection from arm (15-30ml)</li>
                          <li style={{ marginBottom: "8px" }}><strong>Centrifugation:</strong> Blood processing to separate platelet-rich plasma</li>
                          <li style={{ marginBottom: "8px" }}><strong>Platelet Activation:</strong> Activating growth factors in the PRP</li>
                          <li style={{ marginBottom: "8px" }}><strong>Injection:</strong> Precise PRP injection into scalp treatment areas</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Key Features:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}><strong>No Downtime:</strong> Immediate return to work and daily activities</li>
                      <li style={{ marginBottom: "8px" }}><strong>Minimal Discomfort:</strong> Topical anesthesia for comfort during injections</li>
                      <li style={{ marginBottom: "8px" }}><strong>Natural Process:</strong> Uses your body's own healing mechanisms</li>
                      <li><strong>Comprehensive Treatment:</strong> Addresses multiple hair loss factors simultaneously</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20line",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Treatment Sessions & Maintenance
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Initial Treatment Phase:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}><strong>Session 1-3:</strong> Monthly treatments for optimal activation</li>
                      <li style={{ marginBottom: "10px" }}><strong>Session 4-6:</strong> Bi-monthly sessions for consolidation</li>
                      <li style={{ marginBottom: "10px" }}><strong>Evaluation:</strong> Progress assessment after initial phase</li>
                      <li style={{ marginBottom: "10px" }}><strong>Customization:</strong> Adjustment of protocol based on response</li>
                      <li><strong>Maintenance:</strong> Quarterly or semi-annual sessions for sustained results</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Combination Therapies:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>PRP with topical minoxidil for enhanced results</li>
                      <li style={{ marginBottom: "10px" }}>PRP with oral supplements for comprehensive approach</li>
                      <li style={{ marginBottom: "10px" }}>PRP with low-level laser therapy (LLLT)</li>
                      <li style={{ marginBottom: "10px" }}>PRP with hair growth serums and peptides</li>
                      <li>PRP as preparatory treatment before hair transplant</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Protocols:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Customized platelet concentration based on individual needs</li>
                      <li style={{ marginBottom: "10px" }}>Precision injection techniques for optimal follicle targeting</li>
                      <li>Progress monitoring with trichoscopy and photography</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Results Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              PRP Results & Growth Timeline
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Month 1-2",
                    title: "Initial Response",
                    activities: ["Reduced hair shedding", "Improved scalp health", "Stronger hair roots", "Decreased breakage"]
                  },
                  {
                    period: "Month 3-4",
                    title: "Early Growth",
                    activities: ["New fine hairs appear", "Increased hair thickness", "Better hair density", "Visible improvement"]
                  },
                  {
                    period: "Month 5-6",
                    title: "Significant Progress",
                    activities: ["Noticeable regrowth", "Enhanced volume", "Improved coverage", "Stronger hair texture"]
                  },
                  {
                    period: "Month 7-12",
                    title: "Optimal Results",
                    activities: ["Maximum density", "Mature hair growth", "Long-lasting results", "Maintenance phase"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Aftercare & Maintenance */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Post-Treatment Care & Maintenance
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Immediate Aftercare</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Avoid washing hair for 24-48 hours after treatment</li>
                      <li style={{ marginBottom: "10px" }}>Skip strenuous exercise and sweating for 2 days</li>
                      <li style={{ marginBottom: "10px" }}>Use gentle, sulfate-free shampoo when resuming hair wash</li>
                      <li>Avoid hair coloring or chemical treatments for 1 week</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Long-term Maintenance</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Follow recommended maintenance session schedule</li>
                      <li style={{ marginBottom: "10px" }}>Maintain healthy diet rich in proteins and vitamins</li>
                      <li style={{ marginBottom: "10px" }}>Use prescribed hair growth supplements if recommended</li>
                      <li>Practice stress management and adequate sleep</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "How painful is PRP treatment for hair loss?",
                  answer: "PRP treatment is generally well-tolerated with minimal discomfort. Most patients describe the sensation as mild pinpricks during the injections. We use topical anesthesia to numb the scalp before the procedure, which significantly reduces any discomfort. The blood draw from the arm feels similar to a routine blood test. Some patients may experience mild soreness or tenderness in the treated areas for a few hours after the procedure, but this typically resolves quickly. The entire process is much less uncomfortable than most people anticipate, and the minimal discomfort is considered well worth the significant hair restoration benefits. Most patients return to their normal activities immediately after the treatment without any pain or limitations."
                },
                {
                  question: "How many PRP sessions are needed for optimal results?",
                  answer: "The number of PRP sessions needed varies based on individual hair loss severity and response to treatment. Typically, we recommend: Initial Phase: 3-6 sessions spaced 4-6 weeks apart for optimal activation; Maintenance Phase: Quarterly or semi-annual sessions to sustain results. For mild to moderate hair loss, 3-4 initial sessions often show significant improvement. For more advanced hair loss, 5-6 sessions may be recommended. The treatment works cumulatively, with each session building upon the previous ones. Most patients begin noticing reduced hair fall within 4-6 weeks after the first session and visible new growth by 3 months. Regular maintenance sessions are important to preserve the results, as hair loss is typically an ongoing process that requires continued management."
                },
                {
                  question: "How long do PRP results last for hair regrowth?",
                  answer: "PRP results can last significantly with proper maintenance. The initial results from a complete treatment series typically last 12-18 months. However, since hair loss is often progressive, maintenance sessions are recommended to sustain the results long-term. Most patients benefit from quarterly or semi-annual maintenance sessions after the initial treatment phase. The longevity of results depends on several factors: The underlying cause and progression rate of hair loss; Individual response to PRP therapy; Adherence to maintenance protocol; Overall health and lifestyle factors; Genetic predisposition to hair loss. With regular maintenance, many patients enjoy sustained hair improvement for years. PRP not only stimulates new growth but also strengthens existing hair, making it more resistant to future loss."
                },
                {
                  question: "Is PRP treatment safe and are there any side effects?",
                  answer: "PRP treatment is extremely safe because it uses your own blood components, eliminating risks of allergic reactions or rejection. Since it's an autologous treatment (using your own biological material), there's no risk of disease transmission or foreign substance reactions. Possible minor side effects include: Temporary mild swelling or redness at injection sites (resolves within hours); Minor bruising or tenderness in treated areas; Temporary headache in some cases (rare). These side effects are typically mild and resolve within 24-48 hours. Serious complications are extremely rare when performed by qualified professionals. PRP is considered one of the safest hair restoration treatments available, with millions of procedures performed worldwide without significant adverse effects. The safety profile makes it suitable for most healthy individuals seeking hair loss treatment."
                },
                {
                  question: "Can PRP be combined with other hair loss treatments?",
                  answer: "Yes, PRP combines very effectively with other hair loss treatments and often enhances their results. Common combinations include: PRP with Minoxidil: Topical minoxidil enhances blood flow while PRP provides growth factors; PRP with Finasteride: Oral medication reduces DHT while PRP stimulates growth; PRP with Low-Level Laser Therapy (LLLT): Combined approach for comprehensive follicle stimulation; PRP with Hair Supplements: Nutritional support for optimal hair health; PRP with Hair Transplant: PRP can prepare scalp for transplant and improve graft survival post-surgery. Combination therapies often yield better results than single treatments alone, as they address hair loss from multiple angles. Your dermatologist can create a customized combination protocol based on your specific hair loss pattern, causes, and treatment goals for optimal outcomes."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Ready to Regrow Your Hair?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert team provides natural hair regrowth with advanced PRP therapy and personalized treatment plans.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Trichology: <strong>080-6541-7705</strong> | Dermatology: <strong>080-6541-7715</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default HairfallPRP;